import React from "react";
import { ShieldCheck, Hammer, Users, BadgeCheck } from "lucide-react";

export const HeroBadges = ({ t }) => {
  const badges = [
    { id: "experience", icon: ShieldCheck, label: t.hero.badge1 },
    { id: "latinx", icon: Users, label: t.hero.badge2 },
    { id: "family", icon: Hammer, label: t.hero.badge3 },
    { id: "licensed", icon: BadgeCheck, label: t.hero.badge4 },
  ];
  return (
    <>
      <div className="mt-10 md:mt-14 grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-8 max-w-3xl">
        {badges.map((b, i) => (
          <div
            key={b.id}
            data-testid={`hero-badge-${i}`}
            className="flex flex-col md:flex-row items-start md:items-center gap-2 md:gap-3 text-white/90"
          >
            <b.icon className="w-5 h-5 md:w-6 md:h-6 text-brand-accent flex-shrink-0" strokeWidth={2} />
            <span className="font-display font-semibold text-xs md:text-sm leading-tight">{b.label}</span>
          </div>
        ))}
      </div>
      <div
        data-testid="hero-credentials"
        className="mt-5 inline-flex items-center gap-2 border border-white/25 bg-white/5 backdrop-blur-sm px-3 py-1.5 text-white/90"
      >
        <ShieldCheck className="w-3.5 h-3.5 text-brand-accent flex-shrink-0" strokeWidth={2.5} />
        <span className="font-display font-semibold text-[11px] md:text-xs tracking-wide uppercase">
          {t.footer.credentials}
        </span>
      </div>
    </>
  );
};

export const HeroStrip = ({ t }) => (
  <div className="hidden md:flex absolute bottom-0 left-0 right-0 bg-brand-accent">
    <div className="max-w-7xl mx-auto w-full px-5 md:px-8 lg:px-12 py-3 flex items-center justify-between text-white">
      <span className="font-display font-bold text-sm tracking-wide uppercase">{t.hero.strip}</span>
      <a href={`tel:${t.phone.tel}`} data-testid="hero-strip-phone" className="font-display font-black text-lg hover:underline">
        {t.phone.display}
      </a>
    </div>
  </div>
);
